const PageHeader = ({ overline, title, accent, subtitle, testId, bgImage, bgPosition = "center" }) => {
  return (
    <section
      className="relative pt-36 pb-14 md:pt-44 md:pb-20 overflow-hidden"
      data-testid={testId || "page-header"}
    >
      {bgImage && (
        <>
          <div
            className="absolute inset-0"
            style={{
              backgroundImage: `url('${bgImage}')`,
              backgroundSize: "cover",
              backgroundPosition: bgPosition,
              opacity: 0.35,
            }}
          />
          <div
            className="absolute inset-0"
            style={{
              background:
                "linear-gradient(180deg, rgba(20,18,16,0.5) 0%, rgba(20,18,16,0.75) 70%, #141210 100%)",
            }}
          />
        </>
      )}
      <div className="glow-green -top-40 -left-40" />
      <div className="glow-blue -top-20 right-0" />
      <div className="relative max-w-[1400px] mx-auto px-6 md:px-12">
        {overline && (
          <p className="overline mb-5" data-testid="page-overline">
            {overline}
          </p>
        )}
        <h1
          className="font-heading font-black text-5xl sm:text-6xl md:text-7xl lg:text-[6.5rem] uppercase leading-[0.9] tracking-tight max-w-5xl"
          data-testid="page-title"
        >
          {title} {accent && <span className="text-forest-glow">{accent}</span>}
        </h1>
        {subtitle && (
          <p
            className="mt-6 text-lg md:text-xl text-white/70 max-w-2xl leading-relaxed"
            data-testid="page-subtitle"
          >
            {subtitle}
          </p>
        )}
      </div>
    </section>
  );
};

export default PageHeader;
